export const SuggestionsQuestions32 =[
    {
        id: 'SB2-01',
        category: '一般閱讀題',
        type: '選擇題',
        question: '荊軻起初推辭太子丹的請求，篇章主要如何解釋？',
        options: [
            {
                option: 'A. 明白國家大事責任重大，不能輕率答應'
            },
            {
                option: 'B. 早已與秦王商量投降'
            },
            {
                option: 'C. 因為秦舞陽已經逃走'
            },
            {
                option: 'D. 確定太子丹不會再請求'
            }
        ],
        correctAnswer: 'A. 明白國家大事責任重大，不能輕率答應',
        explanation: '正文指他明白責任重大，待太子再三請求才答應。',
        score: 1,
        source: '篇章一・受託赴秦',
        articleIndex: [0]
    },
    {
        id: 'SB2-02',
        category: '一般閱讀題',
        type: '選擇題',
        question: '送行者穿白衣白冠，在本段有何含義？',
        options: [
            {
                option: 'A. 表示荊軻已完成刺秦任務'
            },
            {
                option: 'B. 暗示此行可能一去不返，帶出悲壯氣氛'
            },
            {
                option: 'C. 說明當天舉行婚禮'
            },
            {
                option: 'D. 證明所有人都對成功毫無疑問'
            }
        ],
        correctAnswer: 'B. 暗示此行可能一去不返，帶出悲壯氣氛',
        explanation: '注釋說明這是喪服，結合出發處境帶出死亡預感。',
        score: 1,
        source: '篇章一・易水送別',
        articleIndex: [0]
    },
    {
        id: 'SB2-03',
        category: '一般閱讀題',
        type: '選擇題',
        question: '劉邦受到酈食其批評後，做了甚麼？',
        options: [
            {
                option: 'A. 立即將酈食其逐出軍營'
            },
            {
                option: 'B. 繼續洗腳並命人沉默'
            },
            {
                option: 'C. 停止洗腳，整衣請上座並道歉'
            },
            {
                option: 'D. 立刻把帝位讓給酈食其'
            }
        ],
        correctAnswer: 'C. 停止洗腳，整衣請上座並道歉',
        explanation: '正文以連串動作寫其態度改變。',
        score: 1,
        source: '篇章二・劉邦願意改變姿態',
        articleIndex: [1]
    },
    {
        id: 'SB2-04',
        category: '一般閱讀題',
        type: '選擇題',
        question: '「互見法」在本篇指甚麼？',
        options: [
            {
                option: 'A. 每一篇只記同一天發生的事情'
            },
            {
                option: 'B. 把所有人物寫成相同性格'
            },
            {
                option: 'C. 刪去人物傳記之外的所有材料'
            },
            {
                option: 'D. 同一人物的事跡分見不同篇章，合讀才能較完整理解'
            }
        ],
        correctAnswer: 'D. 同一人物的事跡分見不同篇章，合讀才能較完整理解',
        explanation: '文中以劉邦棄子等事跡分見其他傳記作例。',
        score: 1,
        source: '篇章二・彭城之戰',
        articleIndex: [1]
    },
    {
        id: 'SB2-05',
        category: '一般閱讀題',
        type: '選擇題',
        question: '兩篇共同指出《史記》人物令人難忘的主要原因是甚麼？',
        options: [
            {
                option: 'A. 透過具體言行與處境呈現複雜性情，不能只以成敗判斷'
            },
            {
                option: 'B. 人物只要勝利便會被後人記住'
            },
            {
                option: 'C. 史家從不描寫人物缺點'
            },
            {
                option: 'D. 每位人物都長篇解釋自己內心'
            }
        ],
        correctAnswer: 'A. 透過具體言行與處境呈現複雜性情，不能只以成敗判斷',
        explanation: '荊軻雖敗仍鮮明，劉項則各有多面形象，靠言行細節呈現。',
        score: 1,
        source: '篇章一及篇章二',
        articleIndex: [0, 1]
    },
    {
        id: 'SB2-06',
        category: '一般閱讀題',
        type: '短答題',
        question: '荊軻為甚麼等待？太子丹的懷疑怎樣改變了他的行動？',
        correctAnswer: '他等住得遠的同伴同行；被疑反悔後發怒責問，停止等待並出發。',
        explanation: '他等住得遠的同伴同行（2分）；被疑反悔後發怒責問，停止等待並出發（2分）。',
        score: 4,
        source: '篇章一・出發前的等待',
        articleIndex: [0]
    },
    {
        id: 'SB2-07',
        category: '一般閱讀題',
        type: '短答題',
        question: '荊軻的「顧笑」及「前謝」如何化解秦廷上的危機？',
        correctAnswer: '秦舞陽色變發抖令群臣生疑；荊軻先笑以示鎮定，再把同伴反應解作偏遠者初見天子的畏懼，使進見繼續。',
        explanation: '秦舞陽色變發抖令群臣生疑（1分）；荊軻先笑以示鎮定（1分），再把同伴反應解作偏遠者初見天子的畏懼（1分），使進見繼續（1分）。',
        score: 4,
        source: '篇章一・秦廷前的一笑',
        articleIndex: [0]
    },
    {
        id: 'SB2-08',
        category: '一般閱讀題',
        type: '短答題',
        question: '鴻門宴中，項羽與劉邦各呈現甚麼性格？各舉一個行動支持。',
        correctAnswer: '項羽猶豫不決，范增多次示意仍無反應；或有氣度，賜樊噲酒肉；劉邦善把握時機，趁機離席脫身。',
        explanation: '項羽猶豫不決，范增多次示意仍無反應；或有氣度，賜樊噲酒肉（2分）；劉邦善把握時機，趁機離席脫身（2分）。',
        score: 4,
        source: '篇章一・鴻門宴',
        articleIndex: [1]
    },
    {
        id: 'SB2-09',
        category: '一般閱讀題',
        type: '短答題',
        question: '項羽垓下落淚與劉邦歸鄉落淚，是否表示相同處境？說明兩者差異。',
        correctAnswer: '項羽被圍、面對失敗及與虞姬離別，流露悲傷無奈；劉邦已得天下，歸鄉時仍憂誰能守四方，含成功後的不安與感慨。',
        explanation: '項羽被圍、面對失敗及與虞姬離別，流露悲傷無奈（2分）；劉邦已得天下，歸鄉時仍憂誰能守四方，含成功後的不安與感慨（2分）。',
        score: 4,
        source: '篇章二・垓下及沛城',
        articleIndex: [1]
    },
    {
        id: 'SB2-10',
        category: '一般閱讀題',
        type: '短答題',
        question: '用項羽及劉邦各一例，說明《史記》如何不把人物寫成單一的好人或壞人。',
        correctAnswer: '項羽有鉅鹿軍事威勢，也被批評自矜不師古；劉邦能聽取酈生意見，卻在逃亡時棄子。每人須有正負／多面對照。',
        explanation: '項羽有鉅鹿軍事威勢，也被批評自矜不師古（2分）；劉邦能聽取酈生意見，卻在逃亡時棄子（2分）。每人須有正負／多面對照。',
        score: 4,
        source: '篇章二・結語及劉邦、項羽各節',
        articleIndex: [1]
    },
    {
        id: 'SB2-11',
        category: '能力點題',
        type: '選擇題',
        question: '在秦廷上「色變振恐」的人是誰？',
        options: [
            {
                option: 'A. 高漸離'
            },
            {
                option: 'B. 秦舞陽'
            },
            {
                option: 'C. 田光'
            },
            {
                option: 'D. 酈食其'
            }
        ],
        correctAnswer: 'B. 秦舞陽',
        explanation: '正文直接點明秦舞陽見秦王時失態。',
        score: 1,
        source: '篇章一・秦廷前的一笑',
        articleIndex: [0],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: 'SB2-12',
        category: '能力點題',
        type: '選擇題',
        question: '資料庫甲記載劉邦推孩子下車後，是誰把孩子抱回車上？',
        options: [
            {
                option: 'A. 范增'
            },
            {
                option: 'B. 項伯'
            },
            {
                option: 'C. 滕公'
            },
            {
                option: 'D. 烏江亭長'
            }
        ],
        correctAnswer: 'C. 滕公',
        explanation: '原文「滕公常下收載之」。',
        score: 1,
        source: '篇章二・論壇資料庫甲',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: 'SB2-13',
        category: '能力點題',
        type: '短答題',
        question: '摘錄荊軻唱完歌後離去的動作原句，並指出有沒有回頭。',
        correctAnswer: '「於是荊軻就車而去，終已不顧」；始終沒有回頭。',
        explanation: '「於是荊軻就車而去，終已不顧」（2分）；始終沒有回頭（1分）。',
        score: 3,
        source: '篇章一・易水送別',
        articleIndex: [0],
        ability_point: '1.1 獲取並提取文本內信息'
    },
    {
        id: 'SB2-14',
        category: '能力點題',
        type: '短答題',
        question: '劉邦說「此三者，皆人傑也」，資料注釋指出「三者」是誰？',
        correctAnswer: '張良、蕭何、韓信。',
        explanation: '張良、蕭何、韓信，各1分。',
        score: 3,
        source: '篇章二・論壇資料庫丙',
        articleIndex: [1],
        ability_point: '1.1 獲取並提取文本內信息'
    },

    {
        id: 'SB2-15',
        category: '能力點題',
        type: '選擇題',
        question: '要核對「棄子是否也記在其他篇章」，應優先開啟哪個資料入口？',
        options: [
            {
                option: 'A. 乙　分羹'
            },
            {
                option: 'B. 丙　用人'
            },
            {
                option: 'C. 戊　暴行'
            },
            {
                option: 'D. 甲　棄子'
            }
        ],
        correctAnswer: 'D. 甲　棄子',
        explanation: '甲提供〈項羽本紀〉棄子段，可與正文的〈樊酈滕灌列傳〉對讀。',
        score: 1,
        source: '篇章二・論壇資料庫',
        articleIndex: [1],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: 'SB2-16',
        category: '能力點題',
        type: '選擇題',
        question: '要查「項羽列入本紀是否與實際掌政有關」，哪份資料最切合？',
        options: [
            {
                option: 'A. 丁：〈太史公自序〉及「政由羽出」評語'
            },
            {
                option: 'B. 甲：滕公救回孩子的記錄'
            },
            {
                option: 'C. 乙：劉邦和項羽的分羹對話'
            },
            {
                option: 'D. 丙：劉邦自述任用三位人才'
            }
        ],
        correctAnswer: 'A. 丁：〈太史公自序〉及「政由羽出」評語',
        explanation: '丁直接提供本紀編寫方向和項羽歷史地位的材料。',
        score: 1,
        source: '篇章二・論壇資料庫',
        articleIndex: [1],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: 'SB2-17',
        category: '能力點題',
        type: '短答題',
        question: '要研究「荊軻與項羽如何藉歌辭呈現臨別心情」，寫出應閱讀的兩節及各要找的資料類型。',
        correctAnswer: '篇章一「易水送別」，找歌辭、離去動作及送行者反應；篇章二「垓下之圍」，找對虞姬的歌辭、流淚及左右反應。',
        explanation: '篇章一「易水送別」，找歌辭、離去動作及送行者反應（2分）；篇章二「垓下之圍」，找對虞姬的歌辭、流淚及左右反應（2分）。',
        score: 4,
        source: '篇章一、二及論壇資料庫',
        articleIndex: [0, 1],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: 'SB2-18',
        category: '能力點題',
        type: '短答題',
        question: '網民說司馬遷只寫劉邦缺點。列出兩項可優先查閱的材料，並說明各能核對甚麼。',
        correctAnswer: '正文「輟洗、攝衣、延酈生上坐、謝之」可檢視劉邦接受意見的正面行為；資料庫丙「吾能用之」可檢視用人之說，但須標明是劉邦自述。',
        explanation: '正文「輟洗、攝衣、延酈生上坐、謝之」可檢視劉邦接受意見的正面行為（2分）；資料庫丙「吾能用之」可檢視用人之說，但須標明是劉邦自述（2分）。',
        score: 4,
        source: '工作紙2・探究2及論壇資料庫',
        articleIndex: [1],
        ability_point: '1.2 跨來源搜索、導航與篩選'
    },
    {
        id: 'SB2-19',
        category: '能力點題',
        type: '選擇題',
        question: '「圖窮而匕首見」依文中情境應怎樣理解？',
        options: [
            {
                option: 'A. 地圖十分破舊，匕首也消失了'
            },
            {
                option: 'B. 地圖展到盡頭，匕首露出來'
            },
            {
                option: 'C. 荊軻沒有地圖，只能借匕首'
            },
            {
                option: 'D. 秦王讀完地圖後主動交出匕首'
            }
        ],
        correctAnswer: 'B. 地圖展到盡頭，匕首露出來',
        explanation: '「窮」指盡頭，「見」指顯露。',
        score: 1,
        source: '篇章一・圖窮匕見',
        articleIndex: [0],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: 'SB2-20',
        category: '能力點題',
        type: '選擇題',
        question: '「自矜功伐」最接近哪個意思？',
        options: [
            {
                option: 'A. 虛心承認過失'
            },
            {
                option: 'B. 為士兵哀傷'
            },
            {
                option: 'C. 自誇功勞'
            },
            {
                option: 'D. 秘密部署攻城'
            }
        ],
        correctAnswer: 'C. 自誇功勞',
        explanation: '語譯明確解為項羽誇耀自己的功勞。',
        score: 1,
        source: '篇章二・烏江及篇末評語',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: 'SB2-21',
        category: '能力點題',
        type: '短答題',
        question: '分別解釋「莫敢仰視」與「莫能仰視」在各自場景中的意思。',
        correctAnswer: '鉅鹿：諸侯畏懼項羽威勢，不敢抬頭看他；垓下：左右因悲傷而不忍抬頭看他。',
        explanation: '鉅鹿：諸侯畏懼項羽威勢，不敢抬頭看他（2分）；垓下：左右因悲傷而不忍抬頭看他（2分）。',
        score: 4,
        source: '篇章二・鉅鹿及垓下',
        articleIndex: [1],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: 'SB2-22',
        category: '能力點題',
        type: '短答題',
        question: '「事所以不成者，以欲生劫之」中，荊軻聲稱的失敗原因是甚麼？「生劫」是甚麼意思？',
        correctAnswer: '他聲稱因想活捉秦王以取得契約回報太子而未成功；「生劫」指活着劫持，並非直接殺死。須表述為人物自述。',
        explanation: '他聲稱因想活捉秦王以取得契約回報太子而未成功（2分）；「生劫」指活着劫持，並非直接殺死（2分）。須表述為人物自述。',
        score: 4,
        source: '篇章一・圖窮匕見',
        articleIndex: [0],
        ability_point: '2.1 建構文本字面意義'
    },
    {
        id: 'SB2-23',
        category: '能力點題',
        type: '選擇題',
        question: '從「終已不顧」最合理可推知荊軻哪種狀態？',
        options: [
            {
                option: 'A. 已經忘記任務內容'
            },
            {
                option: 'B. 完全不在乎所有送行者'
            },
            {
                option: 'C. 確定此行不會遇上危險'
            },
            {
                option: 'D. 下定決心離去，情緒收在行動之中'
            }
        ],
        correctAnswer: 'D. 下定決心離去，情緒收在行動之中',
        explanation: '不回頭的動作可呈現決絕，不能推出毫無感情或必能成功。',
        score: 1,
        source: '篇章一・易水送別',
        articleIndex: [0],
        ability_point: '2.2 生成推斷'
    },
    {
        id: 'SB2-24',
        category: '能力點題',
        type: '選擇題',
        question: '「安得猛士兮守四方」最能推知劉邦哪一層心情？',
        options: [
            {
                option: 'A. 雖已成功，仍憂慮如何守住天下'
            },
            {
                option: 'B. 打算立即放棄已建的漢朝'
            },
            {
                option: 'C. 對天下是否穩固毫不關心'
            },
            {
                option: 'D. 只因飲酒過量才流淚'
            }
        ],
        correctAnswer: 'A. 雖已成功，仍憂慮如何守住天下',
        explanation: '求猛士守四方顯示成功後仍有政治憂慮。',
        score: 1,
        source: '篇章二・沛城的歌與淚',
        articleIndex: [1],
        ability_point: '2.2 生成推斷'
    },
    {
        id: 'SB2-25',
        category: '能力點題',
        type: '短答題',
        question: '根據兩次「笑」的前後處境，推斷荊軻各自的心態。',
        correctAnswer: '秦廷前顧笑，是同伴失態時保持鎮定、設法應變；事敗後倚柱而笑，是明知失敗仍不屈服及不忘受託。',
        explanation: '秦廷前顧笑，是同伴失態時保持鎮定、設法應變（2分）；事敗後倚柱而笑，是明知失敗仍不屈服及不忘受託（2分）。',
        score: 4,
        source: '篇章一・兩次笑',
        articleIndex: [0],
        ability_point: '2.2 生成推斷'
    },
    {
        id: 'SB2-26',
        category: '能力點題',
        type: '短答題',
        question: '由「輟洗、起攝衣、延酈生上坐、謝之」推斷劉邦的兩種性格面向，並交代依據。',
        correctAnswer: '原先洗腳接見長者，見其粗率／傲慢；受批評即停止洗腳、整理衣服、道歉，見其能納諫改變。',
        explanation: '原先洗腳接見長者，見其粗率／傲慢（2分）；受批評即停止洗腳、整理衣服、道歉，見其能納諫改變（2分）。',
        score: 4,
        source: '篇章二・劉邦願意改變姿態',
        articleIndex: [1],
        ability_point: '2.2 生成推斷'
    },
    {
        id: 'SB2-27',
        category: '能力點題',
        type: '選擇題',
        question: '哪項把荊軻的幾個片段連成最有根據的人物理解？',
        options: [
            {
                option: 'A. 從發怒一事可知他任何時候都不能冷靜'
            },
            {
                option: 'B. 慎重受託、受疑發怒、秦廷應變及事敗不屈，呈現多面性情'
            },
            {
                option: 'C. 從任務失敗可知他從未準備'
            },
            {
                option: 'D. 從兩次笑可知他一直心情輕鬆'
            }
        ],
        correctAnswer: 'B. 慎重受託、受疑發怒、秦廷應變及事敗不屈，呈現多面性情',
        explanation: '綜合多個片段可避免用單一情緒概括整個人物。',
        score: 1,
        source: '篇章一・全篇',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id: 'SB2-28',
        category: '能力點題',
        type: '選擇題',
        question: '哪組材料最能呈現劉邦性格中的張力？',
        options: [
            {
                option: 'A. 項羽膝行諸侯與項羽垓下歌'
            },
            {
                option: 'B. 高漸離擊筑與荊軻離去'
            },
            {
                option: 'C. 向酈食其道歉與逃亡時棄子'
            },
            {
                option: 'D. 廉頗進食與趙王不召'
            }
        ],
        correctAnswer: 'C. 向酈食其道歉與逃亡時棄子',
        explanation: '兩件劉邦的事分別顯示納諫與冷酷，須在篇內整合。',
        score: 1,
        source: '篇章二・劉邦的相關段落',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id: 'SB2-29',
        category: '能力點題',
        type: '短答題',
        question: '篇章二較早寫諸侯「膝行而前，莫敢仰視」，垓下則寫「左右皆泣，莫能仰視」。讀過鉅鹿的威勢，再讀垓下的歌與淚，你對項羽有甚麼更深的理解？請連繫兩處文字說明。',
        correctAnswer: '鉅鹿的低首出於畏懼威勢；垓下的低首出於悲傷不忍；前後照應形成盛衰落差，使英雄末路更可感。',
        explanation: '鉅鹿的低首出於畏懼威勢（2分）；垓下的低首出於悲傷不忍（2分）；前後照應形成盛衰落差，使英雄末路更可感（2分）。',
        score: 6,
        source: '工作紙2・探究3（2）',
        articleIndex: [1],
        ability_point: '2.3 整合文本內信息',
        isSuggested: true
    },
    {
        id: 'SB2-30',
        category: '能力點題',
        type: '短答題',
        question: '連繫「起初推辭」「等待同伴」「受疑後出發」，說明荊軻是否只能被概括為「一時衝動的人」。',
        correctAnswer: '起初推辭顯示慎重，等同伴顯示有安排；受疑後發怒立即出發亦顯出情緒反應；因此性格有張力，不能只用一時衝動概括全部。',
        explanation: '起初推辭顯示慎重，等同伴顯示有安排（2分）；受疑後發怒立即出發亦顯出情緒反應（1分）；因此性格有張力，不能只用一時衝動概括全部（1分）。',
        score: 4,
        source: '篇章一・受託赴秦至出發前的等待',
        articleIndex: [0],
        ability_point: '2.3 整合文本內信息'
    },
    {
        id: 'SB2-31',
        category: '能力點題',
        type: '選擇題',
        question: '比較易水送別與垓下惜別，哪項最準確？',
        options: [
            {
                option: 'A. 兩人都已取得天下，只是思鄉'
            },
            {
                option: 'B. 兩段歌聲都表示對成功的確定'
            },
            {
                option: 'C. 只要兩段都有歌聲，心情就完全一致'
            },
            {
                option: 'D. 前者以歌與離去動作顯赴難決心，後者以歌與淚顯敗局中的無奈'
            }
        ],
        correctAnswer: 'D. 前者以歌與離去動作顯赴難決心，後者以歌與淚顯敗局中的無奈',
        explanation: '須把相近描寫放回不同處境，不能僅憑形式相同便判情感相同。',
        score: 1,
        source: '篇章一・易水送別；篇章二・垓下',
        articleIndex: [0, 1],
        ability_point: '2.4 整合跨文本信息'
    },
    {
        id: 'SB2-32',
        category: '能力點題',
        type: '選擇題',
        question: '荊軻任務失敗與項羽最終失敗，兩篇對人物價值有何共同提示？',
        options: [
            {
                option: 'A. 失敗不會抹去可細讀的言行與性情，但也不免除對缺點的檢視'
            },
            {
                option: 'B. 失敗者所有決定都正確'
            },
            {
                option: 'C. 失敗者必定比成功者高尚'
            },
            {
                option: 'D. 成功與失敗都不屬於歷史研究內容'
            }
        ],
        correctAnswer: 'A. 失敗不會抹去可細讀的言行與性情，但也不免除對缺點的檢視',
        explanation: '兩篇超越成敗單一標準，同時保留批判與多面描寫。',
        score: 1,
        source: '篇章一及篇章二',
        articleIndex: [0, 1],
        ability_point: '2.4 整合跨文本信息'
    },
    {
        id: 'SB2-33',
        category: '能力點題',
        type: '短答題',
        question: '從易水送別與垓下惜別各選一處歌辭、動作或旁人反應，連同人物處境，說明兩者的心情有何分別。',
        correctAnswer: '荊軻例：「終已不顧」，赴秦前決絕／悲壯；項羽例：「虞兮虞兮奈若何」，被圍時對離別與敗局無奈；明確比較而非只說同樣悲傷。',
        explanation: '荊軻例：「終已不顧」，赴秦前決絕／悲壯（2分）；項羽例：「虞兮虞兮奈若何」，被圍時對離別與敗局無奈（2分）；明確比較而非只說同樣悲傷（2分）。',
        score: 6,
        source: '工作紙2・探究3（1）',
        articleIndex: [0, 1],
        ability_point: '2.4 整合跨文本信息',
        isSuggested: true
    },
    {
        id: 'SB2-34',
        category: '能力點題',
        type: '短答題',
        question: '兩篇怎樣透過旁人的反應突出主要人物？各舉一例，指出不同效果。',
        correctAnswer: '秦舞陽色變振恐與荊軻鎮定形成對比，突出荊軻應變；諸侯膝行不敢仰視從側面突出項羽威勢。',
        explanation: '秦舞陽色變振恐與荊軻鎮定形成對比，突出荊軻應變（2分）；諸侯膝行不敢仰視從側面突出項羽威勢（2分）。',
        score: 4,
        source: '篇章一・秦廷前的一笑；篇章二・鉅鹿之戰',
        articleIndex: [0, 1],
        ability_point: '2.4 整合跨文本信息'
    },

    {
        id: 'SB2-35',
        category: '能力點題',
        type: '選擇題',
        question: '論壇稱「項羽的惡行比劉邦多十倍都不止」，資料庫戊只列一項暴行。最合理的評估是甚麼？',
        options: [
            {
                option: 'A. 既有一例，十倍之說已獲證實'
            },
            {
                option: 'B. 可支持項羽有暴行記述，不能單憑此證明十倍數量'
            },
            {
                option: 'C. 數字說法不需要界定統計方法'
            },
            {
                option: 'D. 只要不同意帖文，就應否認這項原文記錄'
            }
        ],
        correctAnswer: 'B. 可支持項羽有暴行記述，不能單憑此證明十倍數量',
        explanation: '一項行為證據不足支持倍數，需要範圍、定義與完整統計。',
        score: 1,
        source: '工作紙2・探究2；論壇資料庫戊',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性',
        isSuggested: true
    },
    {
        id: 'SB2-36',
        category: '能力點題',
        type: '選擇題',
        question: '引用「吾能用之，此吾所以取天下也」時，哪個說法最嚴謹？',
        options: [
            {
                option: 'A. 這是司馬遷親口保證唯一成功原因'
            },
            {
                option: 'B. 這是項羽承認自己毫無才智'
            },
            {
                option: 'C. 這是劉邦對成功原因的自述，可再用實際言行核對'
            },
            {
                option: 'D. 這段可直接證明所有臣下都同意劉邦'
            }
        ],
        correctAnswer: 'C. 這是劉邦對成功原因的自述，可再用實際言行核對',
        explanation: '須辨明說話者，人物自述不能直接等同史家全盤定論。',
        score: 1,
        source: '篇章二・論壇資料庫丙',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性'
    },
    {
        id: 'SB2-37',
        category: '能力點題',
        type: '短答題',
        question: '網民以項羽入「本紀」證明司馬遷偏愛他。用資料庫丁評估這個推論，指出一項支持材料和一項不能確定之處。',
        correctAnswer: '「政由羽出」及曾分封王侯支持其重要歷史地位，入本紀可有編史理由；不能僅憑分類證明偏愛，也不能因此斷定作者毫無情感取向，須綜合敘事及評語。',
        explanation: '「政由羽出」及曾分封王侯支持其重要歷史地位，入本紀可有編史理由（2分）；不能僅憑分類證明偏愛，也不能因此斷定作者毫無情感取向，須綜合敘事及評語（2分）。',
        score: 4,
        source: '工作紙2・探究2；論壇資料庫丁',
        articleIndex: [1],
        ability_point: '3.1 評估質量與真實性',
        isSuggested: true
    },
    {
        id: 'SB2-38',
        category: '能力點題',
        type: '短答題',
        question: '論壇丁說荊軻失敗後聲稱要活捉秦王「只是替自己開脫」。用正文前後材料評估，並區分可知與未能確定之處。',
        correctAnswer: '前文已說太子希望劫持或刺殺秦王，故活捉說並非與最初計劃全無關係；結尾是荊軻對失敗的自述，可核對一致性，卻不能完全證明內心，也不能無據斷定只是開脫。',
        explanation: '前文已說太子希望劫持或刺殺秦王，故活捉說並非與最初計劃全無關係（2分）；結尾是荊軻對失敗的自述，可核對一致性，卻不能完全證明內心，也不能無據斷定只是開脫（2分）。',
        score: 4,
        source: '工作紙2・探究1；篇章一',
        articleIndex: [0],
        ability_point: '3.1 評估質量與真實性',
        isSuggested: true
    },

    {
        id: 'SB2-39',
        category: '能力點題',
        type: '選擇題',
        question: '連寫抓袖、刺、抽身、袖絕、逐、環柱而走，主要有甚麼效果？',
        options: [
            {
                option: 'A. 用抽象議論交代人物家世'
            },
            {
                option: 'B. 把緊張場面寫成平靜遠景'
            },
            {
                option: 'C. 省去所有人物反應只留下結論'
            },
            {
                option: 'D. 以連續動作加快節奏，呈現突發危機的畫面'
            }
        ],
        correctAnswer: 'D. 以連續動作加快節奏，呈現突發危機的畫面',
        explanation: '動作密集且相連，形成近似分鏡的速度與畫面感。',
        score: 1,
        source: '篇章一・圖窮匕見',
        articleIndex: [0],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id: 'SB2-40',
        category: '能力點題',
        type: '選擇題',
        question: '不直接說項羽威武，改寫諸侯「膝行」「莫敢仰視」，屬哪種寫法及效果？',
        options: [
            {
                option: 'A. 側面描寫，以他人反應突出威勢'
            },
            {
                option: 'B. 心理獨白，直接說項羽內心'
            },
            {
                option: 'C. 純粹列數據，比較兵器數量'
            },
            {
                option: 'D. 倒敘，先寫烏江結局'
            }
        ],
        correctAnswer: 'A. 側面描寫，以他人反應突出威勢',
        explanation: '藉旁人行動呈現項羽的影響力，是側面烘托。',
        score: 1,
        source: '篇章二・鉅鹿之戰',
        articleIndex: [1],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id: 'SB2-41',
        category: '能力點題',
        type: '短答題',
        question: '有人說：「兩個人物都很悲壯，所以讀者會感動。」你會怎樣把這個評語說得更具體？用兩篇各一處原文，解釋字句及前後經歷如何使人物各具性情、牽動讀者。',
        correctAnswer: '荊軻如由受疑發怒轉為「終已不顧」，以沉默動作見決絕；項羽由鉅鹿威勢轉為垓下「泣數行下」，落差見英雄無奈；解釋具體寫法如何產生感受，避免只重複「悲壯」。',
        explanation: '荊軻如由受疑發怒轉為「終已不顧」，以沉默動作見決絕（2分）；項羽由鉅鹿威勢轉為垓下「泣數行下」，落差見英雄無奈（2分）；解釋具體寫法如何產生感受，避免只重複「悲壯」（2分）。',
        score: 6,
        source: '工作紙2・探究3（3）',
        articleIndex: [0, 1],
        ability_point: '3.2 反思內容與形式',
        isSuggested: true
    },
    {
        id: 'SB2-42',
        category: '能力點題',
        type: '短答題',
        question: '「風蕭蕭兮易水寒」如何把環境與情感結合？若只寫「荊軻出發了」，會失去甚麼？',
        correctAnswer: '風聲、水寒構成蕭瑟凜冽的環境，與一去難返的處境連結；只報事件會失去感官氣氛及悲中有壯的情感層次。',
        explanation: '風聲、水寒構成蕭瑟凜冽的環境，與一去難返的處境連結（2分）；只報事件會失去感官氣氛及悲中有壯的情感層次（2分）。',
        score: 4,
        source: '篇章一・易水送別',
        articleIndex: [0],
        ability_point: '3.2 反思內容與形式'
    },
    {
        id: 'SB2-43',
        category: '能力點題',
        type: '選擇題',
        question: '正文引〈樊酈滕灌列傳〉記棄子，資料庫甲又引〈項羽本紀〉記此事。應怎樣處理？',
        options: [
            {
                option: 'A. 兩個來源不同，所以必有一篇全是假'
            },
            {
                option: 'B. 兩處可並存，修正「只記在一篇」的說法'
            },
            {
                option: 'C. 只讀正文便應忽略補充材料'
            },
            {
                option: 'D. 資料庫甲可證明事件記在〈高祖本紀〉'
            }
        ],
        correctAnswer: 'B. 兩處可並存，修正「只記在一篇」的說法',
        explanation: '正文沒說只記一篇；資料庫補足記事分布，不能把〈項羽本紀〉混成〈高祖本紀〉。',
        score: 1,
        source: '篇章二・彭城；論壇資料庫甲',
        articleIndex: [1],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id: 'SB2-44',
        category: '能力點題',
        type: '選擇題',
        question: '甲說司馬遷只美化項羽，乙引用「自矜功伐」反駁。哪個修正最合適？',
        options: [
            {
                option: 'A. 有一句批評便證明作者絕不欣賞項羽'
            },
            {
                option: 'B. 有英雄悲劇描寫便可刪去批評'
            },
            {
                option: 'C. 原文有對項羽的批評，故「只美化」過度；整體態度仍須綜合判斷'
            },
            {
                option: 'D. 兩人意見不同就無法查原文'
            }
        ],
        correctAnswer: 'C. 原文有對項羽的批評，故「只美化」過度；整體態度仍須綜合判斷',
        explanation: '反例足以修正「只」的絕對說法，但不能據單句推斷全部態度。',
        score: 1,
        source: '工作紙2・探究2；篇章二',
        articleIndex: [1],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id: 'SB2-45',
        category: '能力點題',
        type: '短答題',
        question: '丙說荊軻「憑一時血氣答應刺秦，事前連安排也沒有」。找出與此說衝突的兩項正文資料，提出修正。',
        correctAnswer: '他起初推辭，太子再三請求才答應，顯示慎重；他等待同伴，顯示有安排；修正為並非全無考慮或準備，但受疑後發怒出發也呈現情緒一面。',
        explanation: '他起初推辭，太子再三請求才答應，顯示慎重（1分）；他等待同伴，顯示有安排（1分）；修正為並非全無考慮或準備，但受疑後發怒出發也呈現情緒一面（2分）。',
        score: 4,
        source: '工作紙2・探究1丙帖；篇章一',
        articleIndex: [0],
        ability_point: '3.3 發現並處理衝突',
        isSuggested: true
    },
    {
        id: 'SB2-46',
        category: '能力點題',
        type: '短答題',
        question: '有人只摘「分我一桮羹」便說劉邦主動要求殺父。用資料庫乙說明斷章取義在哪裏，並給出較審慎的表述。',
        correctAnswer: '原對話是項羽先以烹父威脅投降，劉邦再借約為兄弟反擊；較審慎可說劉邦在威脅下作強硬／冷酷回應，其效果與倫理可討論，不能直接等同主動要求殺父。',
        explanation: '原對話是項羽先以烹父威脅投降，劉邦再借約為兄弟反擊（2分）；較審慎可說劉邦在威脅下作強硬／冷酷回應，其效果與倫理可討論，不能直接等同主動要求殺父（2分）。',
        score: 4,
        source: '篇章二・論壇資料庫乙',
        articleIndex: [1],
        ability_point: '3.3 發現並處理衝突'
    },
    {
        id: 'SB2-47',
        category: '能力點題',
        type: '選擇題',
        question: '人物短片只剪出一次發怒，便稱該人「一向衝動」。本組閱讀最支持哪項觀看方法？',
        options: [
            {
                option: 'A. 單一表情最能證明終身性格'
            },
            {
                option: 'B. 播放次數多的版本必然較真'
            },
            {
                option: 'C. 只要人物成功便不用查證'
            },
            {
                option: 'D. 補看前後處境和其他行動，再判斷是否能概括整個人'
            }
        ],
        correctAnswer: 'D. 補看前後處境和其他行動，再判斷是否能概括整個人',
        explanation: '如荊軻既怒亦能鎮定，需要多段證據與情境。',
        score: 1,
        source: '篇章一、二；新增媒體情境',
        articleIndex: [0, 1],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id: 'SB2-48',
        category: '能力點題',
        type: '選擇題',
        question: '校刊寫一名同學的人物專訪，哪個做法最能遷移「互見法」的閱讀啟示？',
        options: [
            {
                option: 'A. 比較本人訪談、隊友記錄及活動事例，核對差異後建立完整形象'
            },
            {
                option: 'B. 只用本人最光彩的一句話'
            },
            {
                option: 'C. 把不同人的經歷全寫成同一人的事'
            },
            {
                option: 'D. 把意見不同的來源一律刪去'
            }
        ],
        correctAnswer: 'A. 比較本人訪談、隊友記錄及活動事例，核對差異後建立完整形象',
        explanation: '從多來源整合人物資料可避免單面形象，但仍要核對歸屬與差異。',
        score: 1,
        source: '篇章二・互見法；新增校刊情境',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id: 'SB2-49',
        category: '能力點題',
        type: '短答題',
        question: '朋友轉發「某隊犯規次數是另一隊十倍」但只附一張截圖。借本章論壇查證方法，提出兩個具體核查步驟。',
        correctAnswer: '先查截圖完整來源、日期和前後內容，確認不是個別片段；界定同一賽期、賽事數及犯規定義，核對兩隊完整記錄再比較倍數。',
        explanation: '先查截圖完整來源、日期和前後內容，確認不是個別片段（2分）；界定同一賽期、賽事數及犯規定義，核對兩隊完整記錄再比較倍數（2分）。',
        score: 4,
        source: '工作紙2・探究2；新增網上討論情境',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境'
    },
    {
        id: 'SB2-50',
        category: '能力點題',
        type: '短答題',
        question: '班上選隊長時，有人說「上次贏比賽的同學一定適任」。參考劉項的多面描寫，提出兩項應額外觀察的表現及理由。',
        correctAnswer: '能否聽取意見和改正錯誤，避免只看勝績；能否負責任地對待隊員、兼顧團隊利益，避免忽略冷酷或自負等問題。可用其他合理領導表現，須連繫本章。',
        explanation: '能否聽取意見和改正錯誤，避免只看勝績（2分）；能否負責任地對待隊員、兼顧團隊利益，避免忽略冷酷或自負等問題（2分）。可用其他合理領導表現，須連繫本章。',
        score: 4,
        source: '篇章二・劉邦與項羽；新增校園情境',
        articleIndex: [1],
        ability_point: '4.1 將理解遷移至新情境'
    },

    {
        id: 'SB2-51',
        category: '能力點題',
        type: '選擇題',
        question: '哪句人物卡引言最能準確傳達本組閱讀的新理解？',
        options: [
            {
                option: 'A. 勝者無缺點，敗者無價值'
            },
            {
                option: 'B. 讀一言一動，看見成敗之外的人物多面性'
            },
            {
                option: 'C. 有歌聲的歷史都不可信'
            },
            {
                option: 'D. 只看結局，便知道所有動機'
            }
        ],
        correctAnswer: 'B. 讀一言一動，看見成敗之外的人物多面性',
        explanation: '引言能整合細節寫人與多面觀察，且不作絕對化評斷。',
        score: 1,
        source: '篇章一及篇章二；新增人物卡設計',
        articleIndex: [0, 1],
        ability_point: '4.2 創造並傳達新意義'
    },
    {
        id: 'SB2-52',
        category: '能力點題',
        type: '選擇題',
        question: '要把荊軻的兩次笑剪成對照短片，哪個安排最能避免誤導？',
        options: [
            {
                option: 'A. 只把兩張笑臉接在一起，配「他一直很快樂」'
            },
            {
                option: 'B. 刪去秦舞陽失態，說荊軻在慶功'
            },
            {
                option: 'C. 各保留危機背景與後續言行，字幕分辨「應變」及「不屈」'
            },
            {
                option: 'D. 把事敗之笑移到出發前，說他已知必勝'
            }
        ],
        correctAnswer: 'C. 各保留危機背景與後續言行，字幕分辨「應變」及「不屈」',
        explanation: '保留語境才能讓同一動作傳達不同心態。',
        score: 1,
        source: '篇章一・兩次笑；新增短片設計',
        articleIndex: [0],
        ability_point: '4.2 創造並傳達新意義'
    },
    {
        id: 'SB2-53',
        category: '能力點題',
        type: '短答題',
        question: '選一位網民，回應他的說法。回覆中引用篇章二的原文，並解釋原文與判斷的關係。請標明回覆對象。',
        correctAnswer: '示例回覆@讀史隨筆：「自矜功伐，奮其私智而不師古」是對項羽的批評，因此不能說作者只抬高他；仍應連同其他材料判斷整體態度。',
        explanation: '示例回覆@讀史隨筆：「自矜功伐，奮其私智而不師古」是對項羽的批評，因此不能說作者只抬高他；仍應連同其他材料判斷整體態度。評分：對象及觀點清楚1分；引文準確2分；解釋關係2分；語氣審慎清楚1分。',
        score: 6,
        source: '工作紙2・探究2（3）',
        articleIndex: [1],
        ability_point: '4.2 創造並傳達新意義',
        isSuggested: true
    },
    {
        id: 'SB2-54',
        category: '能力點題',
        type: '短答題',
        question: '為「歌聲中的告別」寫60至100字展覽導語，須比較荊軻與項羽，並用各一個具體細節呈現不同情感。',
        correctAnswer: '示例：易水邊，荊軻唱出一去不返，登車後終不回頭；垓下帳中，項羽問虞姬如何安置，淚落數行。同有歌聲，一個走向未來的危難，一個面對眼前的敗別，人物因此各有性情。',
        explanation: '示例：易水邊，荊軻唱出一去不返，登車後終不回頭；垓下帳中，項羽問虞姬如何安置，淚落數行。同有歌聲，一個走向未來的危難，一個面對眼前的敗別，人物因此各有性情。評分：兩細節準確2分；處境情感比較2分；連貫表達及符合字數2分。',
        score: 6,
        source: '篇章一・易水送別；篇章二・垓下',
        articleIndex: [0, 1],
        ability_point: '4.2 創造並傳達新意義'
    }
];
